export const environment = {
  name: 'dev',
  apiBaseUrl: 'https://sms-dev-api.app.invento.io',
};
